import InfoMessageWithSeeMore from './InfoMessageWithSeeMore';
export default InfoMessageWithSeeMore;

export { type InfoMessageWithSeeMoreProps } from './InfoMessageWithSeeMore';
